import { createContext, useContext } from 'react';

export interface ArcheNavigationValue {
  // Navigate to a page within the arche
  navigateTo: (pageId: string) => void;

  // Go back to the previous page
  goBack: () => void;

  // Page history
  history: string[];

  // Can go back
  canGoBack: boolean;
}

export const ArcheNavigationContext = createContext<ArcheNavigationValue | null>(null);

export function useArcheNavigation(): ArcheNavigationValue {
  const context = useContext(ArcheNavigationContext);
  if (!context) {
    // Return a default no-op implementation if not in provider
    return {
      navigateTo: () => {
        console.warn('Navigation not available outside ArcheProvider');
      },
      goBack: () => {
        console.warn('Navigation not available outside ArcheProvider');
      },
      history: [],
      canGoBack: false,
    };
  }
  return context;
}

export default useArcheNavigation;
